<template>
  <tr class="uploadFile-file">
    <td class="file-actions widthMin">
      <!-- Handled outside vuejs in BSUploadFiles.js -->
      <a href="#" class="removeFile btn btn-sm btn-default bs3-margin-right"><i class="fa-light fa-times" aria-hidden="true"></i></a>
    </td>
    <td class="file-name">
      <span>{{ file.fileName }}</span>
      <input type="hidden" :name="pFileDataFormInputName + '.uploadFiles[' + pIndex + '].fileName'" v-model="file.fileName"/>
    </td>
    <td class="file-category">
      <select :name="pFileDataFormInputName + '.uploadFiles[' + pIndex + '].fileCategoryId'"
              v-model="file.fileCategoryId" class="form-control">
        <option value="-1">{{ 'dictionary.general.none' | i18nText(pDictionary) }}</option>
        <option v-for="fileCategory in pFileCategoryRefs" :value="fileCategory.id" :key="fileCategory.id"
                :selected="file.fileCategoryId === fileCategory.id">{{ fileCategory.name }}</option>
      </select>
    </td>
    <td></td>
  </tr>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "FileUploadTableRow",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFileDataFormInputName: {
      type: String,
      default: function() {
        return 'dataForm';
      }
    },
    pIndex: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    pFile: {
      type: Object,
      required: true
    },
    pFileCategoryRefs: Array
  },
  data: function () {
    return {
      file: this.pFile
    }
  }
}
</script>

<style scoped>

</style>